import { BASEAPIURL } from "./constants";
import Axios from "axios";

const api_url = process.env.REACT_APP_API_URL;

// 401 hatası alındığında token'ı temizleyip login'e yönlendiren fonksiyon
const handle401Error = (error) => {
  if (error.response?.status === 401) {
    // Token'ı ve permissions'ı temizle
    localStorage.removeItem("token");
    localStorage.removeItem("permissions");
    
    // Login sayfasına yönlendir
    window.location.href = "/login";
  }
  return Promise.reject(error);
};

class Api {
  getBaseUrl() {
    return api_url || BASEAPIURL;
  }
  getToken() {
    return localStorage.getItem("token");
  }

  getApi() {
    const axiosInstance = Axios.create({
      baseURL: BASEAPIURL,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + this.getToken(),
      },
    });
    axiosInstance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        console.log(error);
        return handle401Error(error);
      }
    );

    return axiosInstance;
  }
  getApiForBlob() {
    const axiosInstance = Axios.create({
      baseURL: BASEAPIURL,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + this.getToken(),
      },
      responseType: "blob",
    });
    axiosInstance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        console.log(error);
        return handle401Error(error);
      }
    );

    return axiosInstance;
  }
  getApiWithoutToken() {
    const axiosInstance = Axios.create({
      baseURL: BASEAPIURL,
      headers: {
        Accept: "application/json",
      },
    });

    return axiosInstance;
  }
}
export default new Api();
